const Header = () => {

    const burgerWrapper = document.querySelector('.burger-menu');
    const allBurgerButtons = document.querySelectorAll('.header__top-burger');

    if(allBurgerButtons) {
        allBurgerButtons.forEach(burger => {
            burger.addEventListener('click', function() {
                if(burgerWrapper) {
                    if(burgerWrapper.classList.contains('active')) {
                        if(burgerWrapper) {
                            burgerWrapper.classList.remove('active');
                        }
                    } else {
                        if(burgerWrapper) {
                            burgerWrapper.classList.add('active');
                        }
                    }
                }
            })
        });
    }

}

export default Header;